import { copyToClipboard } from '~/shared/utils/copy-to-clipboard';
import { initProCalloutBanners } from '~/shared/modules/pro-callout-banner';
import { DrbToast } from '~/web-components/drb-toast/drb-toast-helpers';
import dribbbleIcon from '~/assets/icons/dribbble-ball-pink.svg?raw';

const bindCopyButtons = () => {
  const copyButtons = document.querySelectorAll('[data-copy-to-clipboard]');

  copyButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      copyToClipboard(e.currentTarget);
    });
  });
};

const bindEventListeners = () => {
  bindCopyButtons();
};

export const initProToast = () => {
  if (!Dribbble?.JsConfig?.user?.isLoggedIn || Dribbble?.JsConfig?.user?.hasPro) return;

  DrbToast.open({
    title: 'Upgrade to Pro and land more clients',
    id: 'pro-callout-toast',
    messageHtml:
      `
        <div class="type-body-m display-flex direction-column gap-12">
          <p>Pro designers get 10X more leads than other designers, and pay no fees when they transact on Dribbble.</p>
          <a href="/pro" class="btn2 btn2--primary-alt btn2--x-small margin-t-4">Learn more</a>
        </div>
      `,
    iconHtml: dribbbleIcon,
    onlyOnce: true,
    cookieDuration: 30,
    cookieName: 'pro_callout_dismissed',
  });
};

document.addEventListener('DOMContentLoaded', async () => {
  // Service create/edit form and select media dialogs
  const { ServiceFormDialog } = await import('~/services/service-form-dialog');
  ServiceFormDialog.init();

  const { ServiceSelectMediaDialog } = await import('~/services/service-select-media-dialog');
  ServiceSelectMediaDialog.init();

  // Missing payout provider warning dialog
  const { ConnectPayoutDialog } = await import('~/marketplace/connect-payout-dialog');
  ConnectPayoutDialog.init();

  bindEventListeners();

  if (!Dribbble?.JsConfig?.user?.hasPro) {
    initProCalloutBanners();
  }

  if (document.querySelector('[data-init-pro-toast]')) {
    initProToast();
  }
});
